<template>
    <h2>Geen resultaten</h2>
    <p>Helaas is er niets dat overeenkomt komt met uw zoekopdracht</p>
    <div class="nothingFound__img">
        <img src="assets/nothingfound.png" alt="">
    </div>
</template>